<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
	<app-buttons
		(save)="submit()"
		(close)="destroy()"
		(discard)="discard()"
		[buttonsWrap]="'panel'"
		[modificar]="modificar"
	></app-buttons>
	<div class="divForm">
		<form [formGroup]="editForm" (onSubmit)="submit()">
			<div style="margin: 20px 5px 20px 5px; text-align: center">
				<mat-label>{{ "GruposInternet" | translate }} <span style="color: red;">*</span></mat-label>

				<customan-dual-list
					[source]="gruposInternetSinAsignar"
					[(destination)]="gruposInternetAsignados"
					key="pkid"
					display="nombre"
					[format]="format"
					[filter]="true"
				>
				</customan-dual-list>
				
				<mat-error *ngIf="formControls['GruposInternetIds'].hasError('required') && formControls['GruposInternetIds'].touched" style="display: block; margin-top: 10px; text-align: left;">
					{{ getErrorMessage("GruposInternetIds") }}
				</mat-error>
			</div>

			<div class="form-group row">
				<div class="form-group-title col-12">
					<h3 class="weight-600">{{ "DatosGenerales" | translate }}</h3>
				</div>
				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "NombreEvento" | translate }}</mat-label>
						<input matInput formControlName="NombreEvento" />
						<mat-error matInput *ngIf="validateFields('NombreEvento')">
							{{ getErrorMessage("NombreEvento") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "DescripcionEvento" | translate }}</mat-label>
						<input matInput formControlName="DescripcionEvento" />
						<mat-error matInput *ngIf="validateFields('DescripcionEvento')">
							{{ getErrorMessage("DescripcionEvento") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "URLImagen" | translate }}</mat-label>
						<input matInput formControlName="URLImagen" />
						<mat-error matInput *ngIf="validateFields('URLImagen')">
							{{ getErrorMessage("URLImagen") }}
						</mat-error>
					</mat-form-field>
				</div>
			</div>

			<div class="form-group row">
				<div class="form-group-title col-12">
					<h3 class="weight-600">{{ "DatosOrganizador" | translate }}</h3>
				</div>
				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "NombreOrganizador" | translate }}</mat-label>
						<input matInput formControlName="NombreOrganizador" />
						<mat-error matInput *ngIf="validateFields('NombreOrganizador')">
							{{ getErrorMessage("NombreOrganizador") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "WebOrganizador" | translate }}</mat-label>
						<input matInput formControlName="WebOrganizador" />
						<mat-error matInput *ngIf="validateFields('WebOrganizador')">
							{{ getErrorMessage("WebOrganizador") }}
						</mat-error>
					</mat-form-field>
				</div>
			</div>

			<div class="form-group row">
				<div class="form-group-title col-12">
					<h3 class="weight-600">{{ "FechasHorarios" | translate }}</h3>
				</div>

				<div class="col-sm-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "FechaDeInicio" | translate }}</mat-label>
						<input
							matInput
							formControlName="FechaDeInicio"
							[matDatepicker]="fechaInicio"
							placeholder="{{ 'FechaDeInicio' | translate }}"
						/>
						<mat-datepicker-toggle
							matSuffix
							[for]="fechaInicio"
						></mat-datepicker-toggle>
						<mat-datepicker #fechaInicio></mat-datepicker>
            
            <mat-error matInput *ngIf="validateFields('FechaDeInicio')">
              {{ getErrorMessage("FechaDeInicio") }}
            </mat-error>
					</mat-form-field>
				</div>

				<div class="col-sm-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "FechaDeFin" | translate }}</mat-label>
						<input
							matInput
							formControlName="FechaDeFin"
							[matDatepicker]="fechaFin"
							placeholder="{{ 'FechaDeFin' | translate }}"
						/>
						<mat-datepicker-toggle
							matSuffix
							[for]="fechaFin"
						></mat-datepicker-toggle>
						<mat-datepicker #fechaFin></mat-datepicker>

            <mat-error matInput *ngIf="validateFields('FechaDeFin')">
              {{ getErrorMessage("FechaDeFin") }}
            </mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "HoraInicio" | translate }}</mat-label>
						<input
							matInput
							formControlName="HoraInicio"
							placeholder="{{ 'SeleccionaHoraInicio' | translate }}"
							type="time"
						/>

            <mat-error matInput *ngIf="validateFields('HoraInicio')">
              {{ getErrorMessage("HoraInicio") }}
            </mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "HoraFin" | translate }}</mat-label>
						<input
							matInput
							formControlName="HoraFin"
							placeholder="{{ 'SeleccionaHoraFin' | translate }}"
							type="time"
						/>

            <mat-error matInput *ngIf="validateFields('HoraFin')">
              {{ getErrorMessage("HoraFin") }}
            </mat-error>
					</mat-form-field>
				</div>
			</div>

			<div class="form-group row">
				<div class="form-group-title col-12">
					<h3 class="weight-600">{{ "DatosAdicionales" | translate }}</h3>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "NombreLugarEvento" | translate }}</mat-label>
						<input matInput formControlName="NombreLugarEvento" />
						<mat-error matInput *ngIf="validateFields('NombreLugarEvento')">
							{{ getErrorMessage("NombreLugarEvento") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "Direccion" | translate }}</mat-label>
						<input matInput formControlName="Direccion" />
						<mat-error matInput *ngIf="validateFields('Direccion')">
							{{ getErrorMessage("Direccion") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "Localidad" | translate }}</mat-label>
						<input matInput formControlName="Localidad" />
						<mat-error matInput *ngIf="validateFields('Localidad')">
							{{ getErrorMessage("Localidad") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "Region" | translate }}</mat-label>
						<input matInput formControlName="Region" />
						<mat-error matInput *ngIf="validateFields('Region')">
							{{ getErrorMessage("Region") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "CodigoPostal" | translate }}</mat-label>
						<input matInput formControlName="CodigoPostal" />
						<mat-error matInput *ngIf="validateFields('CodigoPostal')">
							{{ getErrorMessage("CodigoPostal") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field class="input-select" appearance="outline">
						<mat-label>{{ translation.Pais }}</mat-label>
						<mat-select
							placeholder="{{ translation.Pais }}"
							formControlName="PaisCodigo"
							name="PaisCodigo"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaPaises"
								[value]="element.code"
							>
								{{ element.name }}
							</mat-option>
						</mat-select>
            <mat-error matInput *ngIf="validateFields('PaisCodigo')">
							{{ getErrorMessage("PaisCodigo") }}
						</mat-error>
					</mat-form-field>
				</div>
			</div>

			<div class="form-group row">
				<div class="form-group-title col-12">
					<h3 class="weight-600">{{ "DatosPublicacion" | translate }}</h3>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "PublicacionDesde" | translate }}</mat-label>
						<input
							matInput
							formControlName="PublicacionDesde"
							[matDatepicker]="publicacionDesde"
							placeholder="{{ 'PublicacionDesde' | translate }}"
						/>
						<mat-datepicker-toggle
							matSuffix
							[for]="publicacionDesde"
						></mat-datepicker-toggle>
						<mat-datepicker #publicacionDesde></mat-datepicker>

            <mat-error matInput *ngIf="validateFields('PublicacionDesde')">
              {{ getErrorMessage("PublicacionDesde") }}
            </mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "PublicacionHasta" | translate }}</mat-label>
						<input
							matInput
							formControlName="PublicacionHasta"
							[matDatepicker]="publicacionHasta"
							placeholder="{{ 'PublicacionHasta' | translate }}"
						/>
						<mat-datepicker-toggle
							matSuffix
							[for]="publicacionHasta"
						></mat-datepicker-toggle>
						<mat-datepicker #publicacionHasta></mat-datepicker>
            <mat-error matInput *ngIf="validateFields('PublicacionHasta')">
              {{ getErrorMessage("PublicacionHasta") }}
            </mat-error>
					</mat-form-field>
				</div>

				<div class="col-12">
					<mat-label>
						{{ 'Activo' | translate }}
						<mat-slide-toggle
							name="Activo"
							formControlName="Activo"
						></mat-slide-toggle>
					</mat-label>
				</div>
			</div>
		</form>
	</div>
</div>
